"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _luxon = require("luxon");

var Address =
/** @class */
function () {
  function Address() {
    this.id = null;
    this.line1 = null;
    this.line2 = null;
    this.state = null;
    this.city = null;
    this.zip = null;
    this.country = null;
    this.continent = null;
    this.timeZone = null;
    this.createdAt = null;
    this.updatedAt = null;
  }

  Address.thaw = function (addressObj) {
    var _a, _b;

    if (addressObj == null) return null;
    var address = new Address();

    if (addressObj.id != null) {
      address.setId(addressObj.id);
    }

    if (addressObj.line1 != null) {
      address.setLine1(addressObj.line1);
    }

    if (addressObj.line2 != null) {
      address.setLine2(addressObj.line2);
    }

    if (addressObj.state != null) {
      address.setState(addressObj.state);
    }

    if (addressObj.city != null) {
      address.setCity(addressObj.city);
    }

    if (addressObj.zip != null) {
      address.setZip(addressObj.zip);
    }

    if (addressObj.country != null) {
      address.setCountry(addressObj.country);
    }

    if (addressObj.continent != null) {
      address.setContinent(addressObj.continent);
    }

    if (addressObj.timeZone != null) {
      address.setTimeZone(addressObj.timeZone);
    }

    if (addressObj.createdAt != null) {
      address.setCreatedAt((_a = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(addressObj.createdAt)) !== null && _a !== void 0 ? _a : null);
    }

    if (addressObj.updatedAt != null) {
      address.setUpdatedAt((_b = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(addressObj.updatedAt)) !== null && _b !== void 0 ? _b : null);
    }

    return address;
  };

  Address.thawList = function (addressObjList) {
    if (addressObjList == null) {
      return [];
    }

    var addresses = [];

    for (var i = 0; i < addressObjList.length; i++) {
      addresses.push(Address.thaw(addressObjList[i]));
    }

    return addresses;
  };

  Address.freeze = function (address) {
    var _a, _b, _c, _d;

    if (address == null) {
      return null;
    }

    var addressObj = {};

    if (address.getId() != null) {
      addressObj.id = address.getId();
    }

    if (address.getLine1() != null) {
      addressObj.line1 = address.getLine1();
    }

    if (address.getLine2() != null) {
      addressObj.line2 = address.getLine2();
    }

    if (address.getState() != null) {
      addressObj.state = address.getState();
    }

    if (address.getCity() != null) {
      addressObj.city = address.getCity();
    }

    if (address.getZip() != null) {
      addressObj.zip = address.getZip();
    }

    if (address.getCountry() != null) {
      addressObj.country = address.getCountry();
    }

    if (address.getContinent() != null) {
      addressObj.continent = address.getContinent();
    }

    if (address.getTimeZone() != null) {
      addressObj.timeZone = address.getTimeZone();
    }

    if (address.getCreatedAt() != null) {
      addressObj.createdAt = (_b = (_a = address.getCreatedAt()) === null || _a === void 0 ? void 0 : _a.toISO()) !== null && _b !== void 0 ? _b : null;
    }

    if (address.getUpdatedAt() != null) {
      addressObj.updatedAt = (_d = (_c = address.getUpdatedAt()) === null || _c === void 0 ? void 0 : _c.toISO()) !== null && _d !== void 0 ? _d : null;
    }

    return addressObj;
  };

  Address.freezeList = function (addresses) {
    if (addresses == null) {
      return [];
    }

    var addressObjList = [];

    for (var i = 0; i < addresses.length; i++) {
      addressObjList.push(Address.freeze(addresses[i]));
    }

    return addressObjList;
  };
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  Address.prototype.setId = function (id) {
    this.id = id;
  };

  Address.prototype.setLine1 = function (line1) {
    this.line1 = line1;
  };

  Address.prototype.setLine2 = function (line2) {
    this.line2 = line2;
  };

  Address.prototype.setState = function (state) {
    this.state = state;
  };

  Address.prototype.setCity = function (city) {
    this.city = city;
  };

  Address.prototype.setZip = function (zip) {
    this.zip = zip;
  };

  Address.prototype.setCountry = function (country) {
    this.country = country;
  };

  Address.prototype.setContinent = function (continent) {
    this.continent = continent;
  };

  Address.prototype.setTimeZone = function (timeZone) {
    this.timeZone = timeZone;
  };

  Address.prototype.setCreatedAt = function (createdAt) {
    this.createdAt = createdAt;
  };

  Address.prototype.setUpdatedAt = function (updatedAt) {
    this.updatedAt = updatedAt;
  };
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  Address.prototype.getId = function () {
    return this.id;
  };

  Address.prototype.getLine1 = function () {
    return this.line1;
  };

  Address.prototype.getLine2 = function () {
    return this.line2;
  };

  Address.prototype.getState = function () {
    return this.state;
  };

  Address.prototype.getCity = function () {
    return this.city;
  };

  Address.prototype.getZip = function () {
    return this.zip;
  };

  Address.prototype.getCountry = function () {
    return this.country;
  };

  Address.prototype.getContinent = function () {
    return this.continent;
  };

  Address.prototype.getTimeZone = function () {
    return this.timeZone;
  };

  Address.prototype.getCreatedAt = function () {
    return this.createdAt;
  };

  Address.prototype.getUpdatedAt = function () {
    return this.updatedAt;
  };
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


  Address.prototype.getCityStateZipCountry = function () {
    return this.city + ', ' + this.state + ' ' + this.zip + ' ' + this.country;
  };

  Address.prototype.getFullAddress = function () {
    return this.line2 ? this.line1 + ' ' + this.line2 + ' ' + this.getCityStateZipCountry() : this.line1 + ' ' + this.getCityStateZipCountry();
  };

  return Address;
}();

var _default = Address;
exports.default = _default;